import { render, staticRenderFns } from "./BoostToTop.vue?vue&type=template&id=4bc64d63&"
import script from "./BoostToTop.vue?vue&type=script&lang=js&"
export * from "./BoostToTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports